import { createSlice } from "@reduxjs/toolkit";

const tierSlice = createSlice({
  name: "tier",
  initialState: [],
  reducers: {
    setTiers: (state, action) => {
      return (state = action.payload);
    },
  },
});
export const { setTiers } = tierSlice.actions;
export default tierSlice.reducer;
